import api from "./api";

class QuestionService {
  async getList() {
    try {
      return await api.get("/amenities/group/list");
    } catch (error) {
      console.error("Error fetching list:", error);
      throw error;
    }
  }

  async getItemByList(id) {
    try {
      return await api.get(`/amenities/item/list/${id}`);
    } catch (error) {
      console.error("Error fetching item by list:", error);
      throw error;
    }
  }

  async create(data) {
    try {
      if (data.id) {
        return await api.post("/question/update", data);
      }
      return await api.post("/question/create", data);
    } catch (error) {
      console.error("Error creating item:", error);
      throw error;
    }
  }

  async destroy(item) {
    if (Array.isArray(item)) {
      return api
        .post("/question/delete", {
          ids: item,
        })
        .then((response) => {
          return response;
        });
    } else if (typeof item === "object" && item !== null && item.id) {
      return api.delete("/question/delete/" + item.id).then((response) => {
        return response;
      });
    }
  }

  async getDataPage(params) {
    try {
      return await api.get("/question/list", { params: params });
    } catch (error) {
      console.error("Error fetching data page:", error);
      throw error;
    }
  }

  async changeStatus(data) {
    try {
      return await this.create(data);
    } catch (error) {
      console.error("Error changing status:", error);
      throw error;
    }
  }
}

export default new QuestionService();
